import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfileService } from 'sigv-library';
import { ApiResponse } from '../models/api-response.model';
import { NewsGroupByDate } from '../models/news-group-by-date.model';
import { News } from '../models/news.model';
import { ApiWebSubmissionService } from './api-web-submission.service';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(
    private webSubmissionService: ApiWebSubmissionService,
    private userService: UserProfileService
  ) {}

  /**
   * @description 通知更新最新通知
   */
  updateNotification: Subject<boolean> = new Subject<boolean>();

  /**
   * 通知已讀 最新消息
   */
  notification(ids: number[]): Observable<void> {
    return this.webSubmissionService
      .doPost('/News/Notification', { id: ids })
      .pipe(map(() => this.updateNotification.next()));
  }

  /**
   * 首頁 查詢最新消息
   */
  queryNews(): Observable<ApiResponse<News>> {
    const useRole = this.userService.currentUserValue?.extranetUserRole;
    const companyId = this.userService.currentUserValue?.companyId;
    return this.webSubmissionService.doGet('/News/List', undefined, {
      'X-UseRole': useRole !== undefined ? useRole.toString() : '',
      'X-CompanyId': companyId !== undefined ? companyId.toString() : '',
    });
  }

  /**
   * 明細頁 查詢最新消息
   */
  queryNewsGroupByDate(): Observable<ApiResponse<{ news: NewsGroupByDate[] }>> {
    const useRole = this.userService.currentUserValue?.extranetUserRole;
    return this.webSubmissionService.doGet('/News/Detail', undefined, {
      'X-UseRole': useRole !== undefined ? useRole.toString() : '',
    });
  }

  /**
   * 刪除 最新消息
   */
  deleteNews(ids: number[]): Observable<void> {
    return this.webSubmissionService.doPost('/News/Delete', { id: ids });
  }

  /**
   * 查看Todo是否存在
   */
  checkTodoExist(req: {
    caseNo: string;
    todoListId: string;
  }): Observable<ApiResponse<boolean>> {
    return this.webSubmissionService.doPost('/News/CheckTodoExist', req);
  }
}
